import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
type LRatingProps = {
  value: number
  label?: string
  labelClass?: string
  tooltip?: string
  size?: string | number,
  readonly?: boolean
  simple?: boolean
}
type LRatingEmits = {
  (e: 'update:modelValue', newValue: number): void
};


export default /*#__PURE__*/_defineComponent({
  __name: 'LRating',
  props: {
    value: null,
    label: null,
    labelClass: { default: 'body-1' },
    tooltip: null,
    size: { default: 32 },
    readonly: { type: Boolean },
    simple: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', newValue: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, label?: string, labelClass: string, tooltip?: string, size: string | number, readonly?: boolean, simple?: boolean }

_useCssVars((_vm, _setup) => ({
  "ec4eee3c": (_vm.size)
}))




const onUpdate = (event: number) => {
  emits('update:modelValue', event);
};

return { __sfc: true,props, emits, onUpdate }
}

})